'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _isFinite = require('babel-runtime/core-js/number/is-finite');

var _isFinite2 = _interopRequireDefault(_isFinite);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class;

var _audioplayer = require('redux/modules/audioplayer');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reactCookie = require('react-cookie');

var _utils = require('helpers/utils');

var _datetime = require('helpers/datetime');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var cookies = new _reactCookie.Cookies();

var _endedHandler = function endedHandler() {};
var useCrossfade = true;
// check audio position every N msec
var checkPositionIntervalMs = 50;
/* stop playback for N msec before the end of the song for gapless playing
 HTML5 audio 'ended' event has a small gap between the song actually ends, so check the end of the song by interval */
var stopBeforeMs = (0, _utils.isIOS)() ? 1500 : 700; // iPhone is very slow to do crossfade in less 1 second
// time before the current audio will be stopped after the next audio starts
var crossfadeDelay = checkPositionIntervalMs * 2;
// volume changes steps count, every 50 ms but not more than 20 steps
var crossfadeSteps = Math.ceil(Math.min(stopBeforeMs / 50, 20));
var startPlayingFrom = 0; // seconds
var defaultTitle = 'No Artist';

var AudioPlayer = (_class = function () {
  function AudioPlayer() {
    var _this = this;

    (0, _classCallCheck3.default)(this, AudioPlayer);

    this.getTrackSrc = function (trackName) {
      return _config2.default.app.srcMasks.audio.replace('<trackName>', trackName);
    };

    this.getPosition = function () {
      return _this.audio ? _this.audio.currentTime : 0;
    };

    this.getDuration = function () {
      var audio = _this.getAudio();

      var res = new _promise2.default(function (resolve, reject) {
        if (!audio) {
          reject(0);
          return res;
        }

        if (audio.readyState) {
          resolve(audio.duration);
        } else {
          _this.audio.addEventListener('loadedmetadata', function onLoaded() {
            resolve(audio.duration);
            audio.removeEventListener('loadedmetadata', onLoaded);
          });
        }
      });

      return res;
    };

    this._volume = Number(cookies.get('volume')) || 1;
    this.audioContainer = {};
    this.positionInterval = 0;
    this.callbacks = {};
    this.status = {
      stop: 'stop',
      play: 'play',
      pause: 'pause'
    };
  }

  (0, _createClass3.default)(AudioPlayer, [{
    key: 'on',
    value: function on(event, cb) {
      if (!this.callbacks[event]) {
        this.callbacks[event] = [];
      }
      this.callbacks[event].push(cb);
    }
  }, {
    key: 'off',
    value: function off(event, cb) {
      var _this2 = this;

      if (!this.callbacks[event]) {
        return false;
      }
      this.callbacks[event].map(function (eventCb, index) {
        if (eventCb === cb) {
          _this2.callbacks[event].splice(index, 1);
        }
      });
    }
  }, {
    key: 'runCallbacks',
    value: function runCallbacks(event) {
      this.callbacks[event].map(function (eventCb) {
        if (eventCb) {
          eventCb();
        }
      });
    }
  }, {
    key: 'getHumanizedPosition',
    value: function getHumanizedPosition() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getPosition();

      return (0, _datetime.secToMin)(position);
    }

    /* Mobile browsers don't have access to play()
     * we create 2 Audio: first for current playing audio and second for precache next audio
     * and switch between them for gapless playing */

  }, {
    key: '_initAudioContainer',
    value: function _initAudioContainer() {
      var audioContainer = this.audioContainer;


      if (!audioContainer.audio) {
        audioContainer.audio = [new Audio(), new Audio()];
        // play() and pause() are needed for mobile devices, where audio can be played only by user interaction
        audioContainer.audio[0].play();
        audioContainer.audio[0].pause();
        audioContainer.audio[1].play();
        audioContainer.audio[1].pause();
        audioContainer.audioIndex = 1;
        audioContainer.queueIndex = 0;
      }
    }
  }, {
    key: '_switchPrecacheActiveAudio',
    value: function _switchPrecacheActiveAudio() {
      this.audioContainer.audioIndex = this.audioContainer.audioIndex ? 0 : 1;
      this.audioContainer.queueIndex = this.audioContainer.queueIndex ? 0 : 1;
      console.log('_switchPrecacheActiveAudio ' + this.audioContainer.audioIndex);
    }
  }, {
    key: 'getAudio',
    value: function getAudio() {
      return this.audioContainer.audio ? this.audioContainer.audio[this.audioContainer.audioIndex] : null;
    }
  }, {
    key: 'getQueuedAudio',
    value: function getQueuedAudio() {
      return this.audioContainer.audio ? this.audioContainer.audio[this.audioContainer.queueIndex] : null;
    }
  }, {
    key: '_startPrecache',
    value: function _startPrecache() {
      var audioContainer = this.audioContainer;

      var audio = this.getQueuedAudio();
      if (!audioContainer.src) {
        return false;
      }

      console.log('start audioContainer to ' + this.audioContainer.queueIndex + ': ' + audioContainer.src);

      if (audio.src === audioContainer.src) {
        this.setCurrentTime(audio, 0);
      } else {
        audio.src = audioContainer.src;
        audio.title = audioContainer.title;
        this.setCurrentTime(audio, 0);
        /* HACK: force preload .mp3 for slow connections
         * Chrome doesn't preload mp3 if connection is slow until audio starting play && volume > 0 */
        audio.preload = 'auto';
        audio.volume = 0.001;
        // audioContainer.initPlayTimer = setTimeout(() => audio.pause(), 150);
        audio.addEventListener('playing', function onLoaded() {
          console.log('on playing callback');
          audio.pause();
          audio.volume = 0;
          audio.removeEventListener('playing', onLoaded);
        });
        audio.play();
      }
    }
  }, {
    key: '_stopPrecacheTimer',
    value: function _stopPrecacheTimer() {
      clearTimeout(this.audioContainer.precacheTimer);
      clearTimeout(this.audioContainer.initPlayTimer);
    }
  }, {
    key: 'updatePrecacheTimer',
    value: function updatePrecacheTimer(duration) {
      if (!this.audio || this.audioContainer.src === this.audio.src) {
        return false;
      }

      var delay = duration - this.getPosition() - _config2.default.app.audioPrecacheBeforeTime;
      if (delay < 0) {
        delay = 0;
      }
      console.log('set precache delay ' + delay);
      this.audioContainer.precacheTimer = setTimeout(this._startPrecache, delay * 1000);
    }
  }, {
    key: 'updatePositionInterval',
    value: function updatePositionInterval(duration) {
      var _this3 = this;

      clearInterval(this.positionInterval);
      var audio = this.audio;

      if (audio) {
        if (duration) {
          this.positionInterval = setInterval(function () {
            if ((duration - _this3.getPosition()) * 1000 < stopBeforeMs) {
              clearInterval(_this3.positionInterval);
              _this3.runCallbacks('ended');
            }
          }, checkPositionIntervalMs);
        } else {
          // rare bug on android when can't calc duration
          audio.removeEventListener('ended', _endedHandler);
          _endedHandler = function endedHandler() {
            audio.removeEventListener('ended', _endedHandler);
            _this3.runCallbacks('ended');
          };
          audio.addEventListener('ended', _endedHandler);
        }
      }
    }
  }, {
    key: 'updatePlayTimers',
    value: function updatePlayTimers() {
      var _this4 = this;

      this._stopPrecacheTimer();

      this.getDuration().then(function (duration) {
        _this4.updatePrecacheTimer(duration);
        _this4.updatePositionInterval(duration);
      });
    }
  }, {
    key: 'clearPrecache',
    value: function clearPrecache() {
      this._stopPrecacheTimer();
    }
  }, {
    key: 'crossfade',
    value: function crossfade(fromAudio, toAudio) {
      console.log('crossfading');
      var fromLeftTime = (fromAudio.duration - fromAudio.currentTime) * 1000;
      if (fromLeftTime && fromLeftTime > checkPositionIntervalMs) {
        var stepDelay = fromLeftTime / crossfadeSteps;
        var fromVolume = fromAudio.volume;
        var toVolume = toAudio.volume;

        var runCrossfadeStep = function runCrossfadeStep(step) {
          var percent = step / crossfadeSteps;
          fromAudio.volume = fromVolume * Math.cos(0.5 * percent * Math.PI);
          toAudio.volume = step === crossfadeSteps ? toVolume : toVolume * Math.cos(0.5 * (1 - percent) * Math.PI);
          // console.log('crossfade from ' + fromAudio.volume);
          // console.log('crossfade to ' + toAudio.volume);
        };

        var crossfadeStep = function crossfadeStep(step) {
          if (step > crossfadeSteps) {
            return fromAudio.pause();
          }
          if (step === 1) {
            runCrossfadeStep(0);
          }
          setTimeout(function () {
            runCrossfadeStep(step);
            crossfadeStep(step + 1);
          }, stepDelay);
        };

        crossfadeStep(1);
      }
    }
  }, {
    key: 'getTitle',
    value: function getTitle(title) {
      return title || defaultTitle;
    }
  }, {
    key: 'setCurrentTime',
    value: function setCurrentTime(audio, time) {
      try {
        audio.currentTime = time;
      } catch (err) {
        // stupid IE workaround
        console.warn('Error: Direct setting of audio.currentTime. Trying to set current time on loadedmetadata', err);
        audio.addEventListener('loadedmetadata', function onLoaded() {
          audio.currentTime = time;
          audio.removeEventListener('loadedmetadata', onLoaded);
        });
      }
    }
  }, {
    key: 'getLeftTime',
    value: function getLeftTime(audio) {
      return (audio.duration - audio.currentTime) * 1000;
    }
  }, {
    key: 'play',
    value: function play() {
      var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._initAudioContainer();
      var precacheAudio = this.getQueuedAudio();
      var currentAudio = null;
      var currentLeft = 0;

      if (current.src) {
        if (precacheAudio && precacheAudio.src === current.src) {
          currentAudio = this.getAudio();
          currentLeft = this.getLeftTime(currentAudio);
          this._switchPrecacheActiveAudio();
          this.audio = this.getAudio();
          this.clearPrecache();
        } else {
          this.audio = this.getAudio();
          this.audio.pause();
          this.audio.src = current.src;
          this.audio.title = this.getTitle(current.title);
        }

        (0, _audioplayer.updatePosition)(0);
        this.volume(this._volume);

        if (next.src) {
          this.audioContainer.src = next.src;
          this.audioContainer.title = this.getTitle(next.title);
        }

        this.setCurrentTime(this.audio, startPlayingFrom);
      }

      if (currentAudio) {
        // is it last seconds of the song?
        // add 2 x checkPositionIntervalMs to be sure that after stop event occurs, song doesn't have a time to progress more than stopBeforeMs time
        if (currentLeft && currentLeft < stopBeforeMs + checkPositionIntervalMs * 2) {
          if (useCrossfade) {
            this.crossfade(currentAudio, this.audio);
          }
        } else {
          setTimeout(function () {
            currentAudio.pause();
            currentAudio.currentTime = startPlayingFrom;
          }, crossfadeDelay);
        }
      }

      if (this.audio) {
        this.audio.play();
        this.updatePlayTimers();
        return true;
      }
      return false;
    }
  }, {
    key: 'pause',
    value: function pause() {
      var audio = this.getAudio();

      if (audio) {
        audio.pause();
        this._stopPrecacheTimer();
        return true;
      }
      return false;
    }
  }, {
    key: 'stop',
    value: function stop() {
      var audio = this.getAudio();

      if (audio) {
        audio.pause();
        this._stopPrecacheTimer();
      }
      this._initAudioContainer();

      return false;
    }
  }, {
    key: 'volume',
    value: function volume() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (val !== null) {
        this._volume = val;
        cookies.set('volume', val, { path: '/' });

        var audio = this.getAudio();
        if (audio) {
          audio.volume = val;
        }
      }
      return this._volume;
    }
  }, {
    key: 'seek',
    value: function seek(sec) {
      var audio = this.getAudio();

      if (audio.src && (0, _isFinite2.default)(sec)) {
        audio.currentTime = sec;
        this.updatePlayTimers();
        return sec;
      }
      return null;
    }
  }, {
    key: 'getPlayingInfo',
    value: function getPlayingInfo(_ref) {
      var track = _ref.track,
          album = _ref.album,
          playerAlbum = _ref.playerAlbum,
          currentPlayerTrack = _ref.currentPlayerTrack,
          playerStatus = _ref.playerStatus;

      var isAlbumPlaying = album.projectId === playerAlbum.projectId;
      var isActiveTrack = isAlbumPlaying && currentPlayerTrack.id === track.id;
      var isPlayerPlaying = playerStatus === this.status.play;
      var isTrackPlaying = isActiveTrack && isPlayerPlaying;

      return { isAlbumPlaying: isAlbumPlaying, isActiveTrack: isActiveTrack, isPlayerPlaying: isPlayerPlaying, isTrackPlaying: isTrackPlaying };
    }
  }]);
  return AudioPlayer;
}(), (_applyDecoratedDescriptor(_class.prototype, '_startPrecache', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_startPrecache'), _class.prototype)), _class);
exports.default = new AudioPlayer();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/AudioPlayer.js
// module id = 135
// module chunks = 1